import React, {Component} from 'react';
import { connect }        from 'react-redux';

//assets
import './top_banner.scss';
import banner_animation from 'assets/mock/banner_animation.mp4';
import banner_animation_mobile from 'assets/mock/banner_animation_mobile.mp4';


class TopBanner extends Component {

    constructor(props) {
        super(props);

        this.state = {
          finished:false,
        };

        this.handleVideoClick = this.handleVideoClick.bind(this);
        this.video = React.createRef();
    }

    componentDidMount(){
        this.video.current.muted = true;
        this.video.current.addEventListener('ended',()=>{
            this.video.current.currentTime = 0;
            this.setState({finished:true});
        });
    }

    handleVideoClick(){
        if (this.state.finished){
            this.video.current.currentTime = 0;
            this.video.current.play();
        } else {
            if (this.video.current.paused) {
                this.video.current.play();
            }
            else {
                this.video.current.pause();
            }
        }
        this.setState({finished:false});
    }

    render() {
        const isMobile = this.props.deviceState === 'mobile';

        return (
            <section className="top_banner">
                <video autoPlay muted ref={this.video} onClick={this.handleVideoClick} playsInline>
                        <source src={isMobile ? banner_animation_mobile : banner_animation} type="video/mp4"/>
                </video>
            </section>
        );
    }
}

//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.Translations
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {

    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(TopBanner);
